module.exports = __webpack_public_path__ + "84b540f7785e4bd08f303289b8343fcf.jpg";